<template>
  <el-menu :default-active="activeMenu"
           active-text-color="#069DCC"
           :mode="mode"
           :router="true"
           @select="handleSelect">
    <template v-for="(menu, index) in menuLists">
      <template v-if="menu.children">
        <el-submenu :index="menu[pathKey]"
                    :key="index">
          <template slot="title">
            <i v-if="menu.icon"
               :class="'iconfont ' +  'icon-' + menu.icon"></i>{{menu[labelKey]}}
          </template>
          <el-menu-item v-for="(tmenu,index) in menu.children"
                        :key="index"
                        :index="tmenu[pathKey]"
                        :route="{path: tmenu[pathKey]}"><span>{{tmenu[labelKey]}}</span></el-menu-item>
        </el-submenu>
      </template>
      <template v-else>
        <el-menu-item :route="{path: menu[pathKey]}"
                      :key="index"
                      :index="menu[pathKey]">
          <i v-if="menu.icon"
             :class="'iconfont ' +  'icon-' + menu.icon"></i>{{menu[labelKey]}}</el-menu-item>
      </template>
    </template>
  </el-menu>
</template>

<script>
export default {
  props: {
    menuLists: {
      type: Array,
      default: () => {
        return []
      }
    },
    menuTemplate: {
      type: Array,
      default: () => {
        return null
      }
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    pathKey: {
      type: String,
      default: 'path'
    },
    mode: {
      type: String,
      default: 'vertical'
    }
  },
  data() {
    return {}
  },
  computed: {
    activeMenu() {
      const route = this.$route
      const { path } = route

      // 这里是为了因为页面的子路由无法匹配，这里强行匹配一级路由
      return '/' + path.split('/')[1]
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.$emit('select')
    },
    renderTemplate(tep, rs) {
      const res = []
      tep.forEach(t => {
        const i = rs.filter(item => item.resourceKey === t.path)[0]
        if (i) {
          if (t.children && t.children.length && i.children && i.children.length) {
            t.children = this.renderTemplate(t.children, i.children)
          } else {
            delete t.children
          }
          res.push(t)
        }
      })

      return res
    }
  }
}
</script>

<style lang="scss" scoped>
.el-menu {
  // background-color: inherit;
  margin: 20px 0;
  border-right: none;
  .el-menu-item,
  /deep/.el-submenu__title {
    font-size: 20px;
    font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI",
      "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue",
      Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      "Segoe UI Symbol";
    font-weight: 400;
    line-height: 43px !important;
    height: 48px !important;

    :hover {
      background-color: inherit;
    }
  }
  &.el-menu--horizontal {
    border: none;
  }
}
</style>
